import React, { useContext, useEffect, useState } from "react";
import { postJsonData } from "../network/ApiController";
import ApiEndpoints from "../network/ApiEndPoints";
import { apiErrorToast, okSuccessToast } from "../utils/ToastUtil";

import {
  FormControl,
  Grid,
  TextField,
  Typography,
  Button,
  Box,
  Select,
  MenuItem,
  Modal,
} from "@mui/material";

import AuthContext from "../store/AuthContext";
import Loader from "../component/loading-screen/Loader";

const PartPaymentElectricity = () => {
  const [loading, setLoading] = useState(false);
  const [params, setParams] = useState([]);
  const [billerName, setBillerName] = useState("");
  const [formData, setFormData] = useState({});
  const [progress, setProgress] = useState(false);
  const [fetchMandatory, setFetchMandatory] = useState("");
  const [billerId, setBillerId] = useState("TATAPWR00DEL01");
  const [amountValue, setAmountValue] = useState("");
  const [directPay, setDirectPay] = useState(false);

  const [billDetails, setBillDetails] = useState(null);
  const [billValue, setBillValue] = useState("");

  const [openModal, setOpenModal] = useState(false);
  const [mpin, setMpin] = useState("");

  const authCtx = useContext(AuthContext);
  const location = authCtx.location;

  const getBillersDetails = () => {
    setLoading(true);

    postJsonData(
      ApiEndpoints.BBPS_GET_BILLERS_DETAILS,
      { billerId: "TATAPWR00DEL01" },
      setLoading,
      (res) => {
        const data = res.data?.data || {};

        setFetchMandatory(data.fetchRequirement);
        setDirectPay(false);
        setAmountValue("");

        let updatedParams = data.parameters || [];

        if (!updatedParams.some((param) => param.desc === "Mobile Number")) {
          updatedParams.push({
            name: "param2",
            desc: "Mobile Number",
            minLength: 10,
            maxLength: 10,
            inputType: "NUMERIC",
            mandatory: 1,
            regex: "^[6-9]d{9}$",
          });
        }

        setParams(updatedParams);
        setBillerName(data.billerInfo?.name || "");

        setLoading(false);
      },
      (err) => {
        apiErrorToast(err);
        setLoading(false);
      },
    );
  };

  const fetchBill = () => {
    const data = {
      billerId: billerId,
      latitude: location.lat,
      longitude: location.long,
      amount: 0,
    };

    params.forEach((item) => {
      data[item.name] = formData[item.name] || "";
    });

    const hasEmptyField = params.some(
      (item) => item.mandatory === 1 && !formData[item.name],
    );

    if (hasEmptyField) {
      apiErrorToast("Please fill all mandatory fields");
      return;
    }

    postJsonData(
      ApiEndpoints.BBPS_FETCH_BILL,
      data,
      setProgress,
      (res) => {
        const responseData = res.data.data.data;

        setBillDetails(responseData);
        setBillValue(responseData.BillAmount);
        setOpenModal(true);
      },
      (err) => {
        setDirectPay(true);
        apiErrorToast(err);
      },
    );
  };

  const payNow = () => {
    if (!mpin || mpin.length < 4) {
      apiErrorToast("Enter valid MPIN");
      return;
    }

    const data = {
      billerId: "PPTATAPWR00DEL01",
      latitude: location.lat,
      biller_name: "Tata Power - Delhi",
      longitude: location.long,
      amount: billValue,
      pf: "web",
      operator: "PPTATAPWR00DEL01",
      mpin: mpin,
      cat: "C04",
      enquiryReferenceId: billDetails?.enquiryReferenceId,
    };

    params.forEach((item) => {
      data[item.name] = formData[item.name] || "";
    });

    postJsonData(
      ApiEndpoints.PART_PAYMENT,
      data,
      setProgress,
      (res) => {
        okSuccessToast(res?.data?.message || "Payment Successful");

        setOpenModal(false);
        setMpin("");
      },
      (err) => {
        apiErrorToast(err);
      },
    );
  };

  useEffect(() => {
    getBillersDetails();
  }, []);

  const handleChange = (e) => {
    const { id, value } = e.target;

    setFormData({
      ...formData,
      [id]: value,
    });
  };

  return (
    <Box
      sx={{
        p: 4,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh",
        bgcolor: "#F7F4EF",
      }}
    >
      <Box
        sx={{
          p: 4,
          width: "100%",
          maxWidth: 500,
          borderRadius: "16px",
          bgcolor: "white",
          boxShadow: "0px 4px 12px rgba(0,0,0,0.1)",
        }}
      >
        <Typography
          variant="h4"
          align="center"
          sx={{
            fontWeight: "bold",
            color: "#D48628",
            mb: 2,
          }}
        >
          Electricity Payment
        </Typography>

        <Box display="flex" justifyContent="center" my={2}>
          <Loader loading={progress} />
        </Box>

        <FormControl fullWidth sx={{ mb: 2 }}>
          <Select value={billerName} displayEmpty>
            <MenuItem value="" disabled>
              Select Provider
            </MenuItem>

            <MenuItem value={billerName}>{billerName}</MenuItem>
          </Select>
        </FormControl>

        <Grid container spacing={2}>
          {params.map((item, index) => (
            <Grid item xs={12} key={index}>
              <TextField
                label={item.desc}
                id={item.name}
                inputProps={{
                  minLength: item.minLength,
                  maxLength: item.maxLength,
                  pattern: item.regex,
                }}
                size="small"
                required={item.mandatory === 1}
                type={item.inputType === "NUMERIC" ? "number" : "text"}
                value={formData[item.name] || ""}
                onChange={handleChange}
                fullWidth
              />
            </Grid>
          ))}

          {directPay && (
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Amount"
                value={amountValue}
                onChange={(e) => {
                  setAmountValue(e.target.value);
                }}
              />
            </Grid>
          )}

          <Grid item xs={12}>
            <Button fullWidth className="btn-background" onClick={fetchBill}>
              Fetch Bill
            </Button>
          </Grid>
        </Grid>

        {/* MODAL */}

        <Modal open={openModal} onClose={() => setOpenModal(false)}>
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: 400,
              bgcolor: "#fff",
              borderRadius: "16px",
              p: 3,
              boxShadow: 24,
            }}
          >
            <Typography
              variant="h6"
              sx={{
                mb: 3,
                fontWeight: 700,
                textAlign: "center",
              }}
            >
              Bill Details
            </Typography>

            <Box sx={{ mb: 3 }}>
              <Typography sx={{ mb: 1 }}>
                <strong>Name:</strong> {billDetails?.CustomerName}
              </Typography>

              <Typography sx={{ mb: 1 }}>
                <strong>Bill Number:</strong> {billDetails?.BillNumber}
              </Typography>

              <Typography sx={{ mb: 1 }}>
                <strong>Bill Date:</strong> {billDetails?.BillDate}
              </Typography>

              <Typography sx={{ mb: 1 }}>
                <strong>Due Date:</strong> {billDetails?.BillDueDate}
              </Typography>

              <Typography sx={{ mb: 1 }}>
                <strong>CA Number:</strong>{" "}
                {billDetails?.CustomerParamsDetails?.[0]?.Value}
              </Typography>
            </Box>

            <TextField
              fullWidth
              label="Amount"
              value={billValue}
              onChange={(e) => setBillValue(e.target.value)}
              sx={{ mb: 3 }}
            />
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                gap: 1,
                mb: 3,
              }}
            >
              {[0, 1, 2, 3, 4, 5].map((item, index) => (
                <TextField
                  key={index}
                  value={mpin[index] || ""}
                  type="password"
                  onChange={(e) => {
                    const value = e.target.value.replace(/\D/g, "");

                    if (!value) return;

                    let newMpin = mpin.split("");
                    newMpin[index] = value[0];

                    setMpin(newMpin.join(""));

                    const nextInput = document.getElementById(
                      `mpin-${index + 1}`,
                    );

                    if (nextInput) {
                      nextInput.focus();
                    }
                  }}
                  onKeyDown={(e) => {
                    if (e.key === "Backspace") {
                      e.preventDefault();

                      let newMpin = mpin.split("");

                      // agar current box filled hai to sirf current clear karo
                      if (newMpin[index]) {
                        newMpin[index] = "";
                        setMpin(newMpin.join(""));
                        return;
                      }

                      // agar current empty hai tab previous pe jao
                      if (index > 0) {
                        newMpin[index - 1] = "";
                        setMpin(newMpin.join(""));

                        const prevInput = document.getElementById(
                          `mpin-${index - 1}`,
                        );

                        if (prevInput) {
                          prevInput.focus();
                        }
                      }
                    }
                  }}
                  inputProps={{
                    maxLength: 1,
                    style: {
                      textAlign: "center",
                      fontSize: "24px",
                      fontWeight: "700",
                      padding: "12px",
                    },
                  }}
                  id={`mpin-${index}`}
                  sx={{
                    width: "50px",
                    "& .MuiOutlinedInput-root": {
                      borderRadius: "12px",
                    },
                  }}
                />
              ))}
            </Box>
            <Button
              fullWidth
              variant="contained"
              className="btn-background"
              onClick={payNow}
            >
              Pay Now
            </Button>
          </Box>
        </Modal>
      </Box>
    </Box>
  );
};

export default PartPaymentElectricity;
